module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-7 col-md-12"
  }, [_c('h1', [_vm._v("Hey " + _vm._s(_vm.user.profile.firstname) + "!")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.matterinfo)
    }
  }, [_vm._v("fff")]), _vm._v(" "), _c('p', [_vm._v("Welcome!")]), _vm._v(" "), _c('p', [_vm._v("Using the PocketLegal service is easy, and starts with two steps. Firstly, answer the questions in the visa tab. Then upload the relevant documents in the documents tab.")]), _vm._v(" "), _c('p', [_vm._v("After we review your documents, we will draft the application, then send it to you for a final review before submitting it.")]), _vm._v(" "), _c('h4', [_vm._v("Office Details")]), _vm._v(" "), _c('p', [_vm._v("Please contact us at any stage throughout the process. We're here to help!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" (02) 8385 1451")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@pocketlegal.com.au"
    }
  }, [_vm._v("info@pocketlegal.com.au")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Office: 162 Redfern Street, Redfern 2016, NSW")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef26debe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clienthome.vue
// module id = 525
// module chunks = 1